/**
 * site.js — global landing config.
 */
const env = import.meta.env ?? {};

export const APP_URL = String(env.VITE_APP_URL ?? '/app').replace(/\/+$/, '');
export const LOGIN_URL = String(env.VITE_LOGIN_URL ?? `${APP_URL}/login`);
export const SIGNUP_URL = String(env.VITE_SIGNUP_URL ?? `${APP_URL}/register`);
export const FORGOT_PASSWORD_URL = String(
  env.VITE_FORGOT_PASSWORD_URL ?? `${APP_URL}/forgot-password`,
);
export const DASHBOARD_URL = String(env.VITE_DASHBOARD_URL ?? `${APP_URL}/chart`);
export const ACCOUNT_URL = String(env.VITE_ACCOUNT_URL ?? `${APP_URL}/account`);
export const PRICING_APP_URL = String(env.VITE_PRICING_APP_URL ?? `${APP_URL}/pricing`);
export const API_URL = String(env.VITE_API_URL ?? '').replace(/\/+$/, '');

export const SITE = {
  name: 'MarketWatcher',
  tagline: 'AI-powered trading terminal',
  contactEmail: 'hello@marketwatcher.app',
  twitter: 'https://x.com/marketwatcher',
  github: 'https://github.com/marketwatcher',
  year: new Date().getFullYear(),
};

export const NAV_LINKS = [
  { to: { path: '/', hash: '#features' }, labelKey: 'features' },
  { to: { path: '/', hash: '#pricing' }, labelKey: 'pricing' },
  { to: { path: '/', hash: '#faq' }, labelKey: 'faq' },
];

export function appPricingUrl(plan, cycle = 'monthly') {
  const base = PRICING_APP_URL;
  if (!plan || plan === 'free') return DASHBOARD_URL;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}plan=${encodeURIComponent(plan)}&cycle=${encodeURIComponent(cycle)}`;
}

export function signupUrl(plan, cycle = 'monthly') {
  const base = SIGNUP_URL;
  if (!plan || plan === 'free') return base;
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}plan=${encodeURIComponent(plan)}&cycle=${encodeURIComponent(cycle)}`;
}
